import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getSitePaymentMethodTypeRequest = {};
var _getSitePaymentMethodTypeResponse = {};
var _listSitePaymentMethodTypesRequest = {};
var _listSitePaymentMethodTypesResponse = {};
function resolveWixPaymentsSitePaymentMethodTypesV1SitePaymentMethodTypeServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/payment-method-types',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/payment-method-types',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/payment-method-types',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/payment-method-types',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves a SitePaymentMethodType. */
export function getSitePaymentMethodType(payload) {
    var _a = serializer(_getSitePaymentMethodTypeRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSitePaymentMethodTypeResponse, {}).fromJSON;
    function __getSitePaymentMethodType(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.payments.site_payment_method_types.v1.site_payment_method_type',
            method: 'GET',
            methodFqn: 'wix.payments.site_payment_method_types.v1.SitePaymentMethodTypeService.GetSitePaymentMethodType',
            url: resolveWixPaymentsSitePaymentMethodTypesV1SitePaymentMethodTypeServiceUrl({
                protoPath: '/v1/site-payment-method-types/{sitePaymentMethodTypeId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSitePaymentMethodType.fromReq = fromReq;
    __getSitePaymentMethodType.__isAmbassador = true;
    return __getSitePaymentMethodType;
}
/** Retrieves a list of SitePaymentMethodTypes. Never returns more than 200 records. */
export function listSitePaymentMethodTypes(payload) {
    var _a = serializer(_listSitePaymentMethodTypesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listSitePaymentMethodTypesResponse, {}).fromJSON;
    function __listSitePaymentMethodTypes(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.payments.site_payment_method_types.v1.site_payment_method_type',
            method: 'GET',
            methodFqn: 'wix.payments.site_payment_method_types.v1.SitePaymentMethodTypeService.ListSitePaymentMethodTypes',
            url: resolveWixPaymentsSitePaymentMethodTypesV1SitePaymentMethodTypeServiceUrl({
                protoPath: '/v1/site-payment-method-types',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listSitePaymentMethodTypes.fromReq = fromReq;
    __listSitePaymentMethodTypes.__isAmbassador = true;
    return __listSitePaymentMethodTypes;
}
//# sourceMappingURL=http.impl.js.map